import { Button, FormControl, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import React from 'react';
import { Controller, UseControllerProps } from 'react-hook-form';

import Checkbox from './checkbox';

const PREFIX = 'ToggleButton';
const classes = {
  btnLabel: `${PREFIX}-btnLabel`,
};

const Label = styled('span')<{ dark?: boolean }>(({ theme, dark }) => ({
  fontSize: 16,
  userSelect: 'none',
  fontWeight: 500,
  color: `${dark ? theme.palette.darkBlue.main : theme.palette.common.white} !important`,
  ['&::focus']: {
    color: `${dark ? theme.palette.darkBlue.main : theme.palette.common.white} !important`,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.btnLabel}`]: {
    backgroundColor: 'transparent',
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
}));

type CommonProps = {
  label: string;
  name?: string;
  fullWidth?: boolean;
  hiddenLabel?: boolean;
  disabled?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  sx?: SxProps<Theme> | undefined;
  dark?: boolean;
};

type ToggleButtonExtProps =
  | {
      value?: boolean;
      onChange?: (value: any) => void;
      controller: UseControllerProps<any>;
    }
  | {
      value: boolean;
      onChange: (value: any) => void;
      controller?: UseControllerProps<any>;
    };

export type ToggleButtonProps = ToggleButtonExtProps & CommonProps;

const ToggleButton: React.FC<ToggleButtonProps> = ({
  label,
  controller,
  value,
  hiddenLabel = false,
  fullWidth = false,
  margin = 'normal',
  disabled = false,
  dark = false,
  sx,
  onChange,
}) => {
  return (
    <FormControl fullWidth={fullWidth} margin={margin}>
      {controller ? (
        <Controller
          {...controller}
          render={({ field }) => {
            return (
              <StyledButton
                fullWidth
                sx={sx}
                disableRipple
                startIcon={
                  <Checkbox
                    sx={{
                      margin: 0,
                    }}
                    dark={dark}
                    checked={field.value}
                    hiddenLabel
                  />
                }
                classes={{
                  root: classes.btnLabel,
                }}
                disabled={disabled}
                onClick={() => {
                  // if (name) field.onChange(name);
                  field.onChange(!field.value);
                }}>
                {hiddenLabel ? '' : <Label dark={dark}>{label}</Label>}
              </StyledButton>
            );
          }}
        />
      ) : (
        <StyledButton
          fullWidth
          disableRipple
          sx={sx}
          startIcon={
            <Checkbox
              sx={{
                margin: 0,
              }}
              dark={dark}
              checked={!!value}
              hiddenLabel
            />
          }
          classes={{
            root: classes.btnLabel,
          }}
          disabled={disabled}
          onClick={() => (onChange ? onChange(!value) : null)}>
          {hiddenLabel ? '' : <Label dark={dark}>{label}</Label>}
        </StyledButton>
      )}
    </FormControl>
  );
};

export default React.memo(ToggleButton);
